<template>
	<div style="padding-top: 40px;">
		<van-form class="form-login" @submit="onSubmit">
			<img class="logo-img" :src="logoImage" alt="Logo" />
			<h3 >{{titleText}}</h3>
			<h2>账号</h2>
			<van-field
				clearable
				v-model="username"
				placeholder="请输入账号"
				type="tel"
				:rules="[{ required: true, message: '请填写账号' }]"
			/>
			<h2>密码</h2>
			<van-field
				v-model="password"
				type="password"
				placeholder="请输入密码"
				:rules="[{ required: true, message: '请填写密码' }]"
			/>
			<div style="margin-top: 32px;">
				<van-button round block type="info" native-type="submit">登录</van-button>
			</div>
		</van-form>
	</div>
</template>
<script>
import { Toast } from "vant";
import { post } from "@/api/post";
import { setToken } from "@/utils/auth";
import global from "@/utils/global";
import { getQueryString } from "@/utils/queryString";
export default {
	data() {
		return {
			username: "",
			password: "",
			text: "获取验证码",
			grade_list: [],
			grade_id: "",
			titleText:  this.findName(), 
			logoImage:this.findlogo(), 
		};
	},
	mounted() {
			this.antoUserInfo();
	},
	methods: {
		antoUserInfo() {
		let p = this.$route.query.p; //自动登陆状态判断
		let code = getQueryString("code");
		if( code && p != 1){
			//调用企业微信自动登陆
			this.toastLoad();
			this.$store
				.dispatch("user/getInfo", code)
				.then(res => {
					// console.log("获取"+res);
					if (res.obj.status == 0) {
						// Toast.fail("自动登陆失败!");
						this.$router.push({ path: "/login?p=1" });
					} else if (
						res.obj.token != undefined ||
						res.obj.token != ""
					) {
						this.token = res.obj.token;
						Toast.fail(res.msg);
						this.$router.push({ path: "/" });
					} else {
						// Toast.fail(res.msg);
						this.$router.push({ path: "/login?p=1" });
					}
				})
				.catch(() => {
					Toast.fail("参数异常!");
					this.$router.push({ path: "/login?p=1" });
				});
		}
		},
		toastLoad() {
			Toast.loading({
				message: "授权中...",
				forbidClick: true,
				duration: this.duration
			});
		},
		findName() {
			return global.Name;
		},
		findlogo() {
			return global.LOGO;
		},
		onSubmit() {
			if (this.username.length != 11) {
				return Toast.fail("请输入正确的手机号");
			}

			post({
				requestType: "login_action",
				user_phone: this.username,
				user_password: this.password,
			})
				.then((res) => {
					if (res.code == 200) {
						setToken(res.obj.token);
						this.$router.push("/");
					} else if (res.code == 401) {
						Toast.fail("用户不存在或密码错误!");
					} else if (res.code == 402) {
						Toast.fail("该用户已被冻结!");
					} else {
						Toast.fail("网络连接错误");
					}
				})
				.catch((res) => {
					console.log(res);
					Toast.fail("网络连接错误,请稍后重试!");
				});
		},
	},
};
</script>

<style lang="scss" scoped>
h3 {
	width: 100%;
	text-align: center;
}

h2 {
	margin: 0;
	padding: 32px 0 10px 0;
	color: rgb(31, 31, 33);
	font-weight: normal;
	font-size: 14px;
	line-height: 16px;
}

.form-login {
	padding: 0 16px;
}

.van-field {
	background-color: #f7f8fa;
	padding: 16px 0;
	border-bottom: 1px solid #d0cfcf;
}

.text {
	margin: 15px auto 0 auto;
	width: 60%;
	font-size: 12px;
	display: flex;
	&-doc {
		text-align: center;
		a {
			color: #2171e8;
		}
	}
}

.check-box {
	display: inline-block;
	flex-shrink: 0;
	margin-right: 5px;
}

.loading {
	top: 0;
	position: fixed;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 8;
}

.select-grade {
	top: 0;
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: #fff;
	z-index: 5;
}


.logo-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100px;
  height: 100px;
}

</style>
